import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { AddCartPromotion, chain, PopulateApiParameter } from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/ApplyPromotion";
import { customAddCartPromotion } from "@NA/Services/AddCartPromotionService";

// this will enable HMR for custom handlers
if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(data => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}

replaceInChain(chain, AddCartPromotion, async props => {
    const result = await customAddCartPromotion(props.apiParameter);
    if (result.successful) {
        props.apiResult = result.result;
        props.successMessage = result.result.message;
    } else {
        props.errorMessage = result.errorMessage!;
    }
});

replaceInChain(chain, PopulateApiParameter, async props => {
    const state = props.getState();
    const { cartId } = state.pages.checkoutReviewAndSubmit;
    const { id } = state.data.carts.byId.current;
    const cart = cartId ? getCartState(state, cartId).value : getCurrentCartState(state).value;
    const currentCart = id ? getCartState(state, id).value : getCurrentCartState(state).value;
    if (!cart && !currentCart) {
        throw new Error("There was no current cart when we were trying to apply a promotion to it.");
    }

    props.apiParameter = {
        cartId: cart?.id ? cart?.id! : currentCart?.id! ,
        promotionCode: props.parameter.promotionCode,
    };
});